import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiGet } from "../../../utils/apiRequests";
import {
  GET_SMP_LIST_LOADING,
  GET_SMP_LIST_ERROR,
  GET_SMP_LIST_SUCCESS,
} from "../../../constant/actionTypes";

export const getSmpList = () => (dispatch) => {
  dispatch({ type: GET_SMP_LIST_LOADING });

  apiGet(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.listleagueSMP}`,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: GET_SMP_LIST_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_SMP_LIST_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: GET_SMP_LIST_ERROR, response: error });
    }
  );
};
